import { useQuery } from '@apollo/client/react'

import { useAccount } from '~publish/contexts/AccountContext'
import { graphql } from '~publish/graphql'

export const QUERY_IDEAS_COUNT = graphql(`
  query ideasCount($input: OrganizationIdInput!) {
    ideasCount(input: $input) {
      ... on IdeasCount {
        count
      }
      ... on CoreWebAppCommonError {
        code
        error
      }
    }
  }
`)

export const useIdeasCount = (): {
  ideasCount: number
} => {
  const { account } = useAccount()
  const organizationId = account?.currentOrganization?.id

  // Read the count straight from the Apollo cache so it stays a live value:
  // mutations that refetch QUERY_IDEAS_COUNT (e.g. creating or deleting an
  // idea) re-render consumers with the updated count without a page reload.
  const { data, dataState } = useQuery(QUERY_IDEAS_COUNT, {
    variables: { input: { organizationId: organizationId ?? '' } },
    skip: !organizationId,
  })

  const completeData = dataState === 'complete' ? data : undefined

  const ideasCount =
    completeData?.ideasCount && 'count' in completeData.ideasCount
      ? completeData.ideasCount.count
      : 0

  return { ideasCount }
}
